import { AbilityBuilder, createMongoAbility } from '@casl/ability'
const { can, build } = new AbilityBuilder(createMongoAbility);

export default function defineAbilityFor(user: any) {
    if (user.temPermissao(['admin_contratos'])) {
        can('manage', 'Contratos');
    }

    if (user && user.temPermissao(['contratos'])) {
        can('read', 'Contratos')

        //RESPONSÁVEL
        can('edit', 'Contratos', {
            'responsavel.mail': { $eq: user.email },
            'status': {
                $in: ['Revisão']
            }
        });

        //GESTOR
        can('edit', 'Contratos', {
            'gestor.mail': { $eq: user.email },
            'status': {
                $in: ['Emitido para o Jurídico',
                    'Revisão para cancelamento']
            }
        });

        //VALIDADOR
        can('edit', 'Contratos', {
            'validador.mail': { $eq: user.email },
            'status': {
                $in: ['Emitido para o verificador',
                    'Em finalização']
            }
        });

    }

    if (user.temPermissao(['editor_contratos'])) {
        can(['create', 'read'], 'Contratos');
        can('edit', 'Contratos', {
            'status': {
                $in: ['Revisão']
            }
        });
    }

    if (user.temPermissao(['site_manager'])) {
        can('read', 'Contratos');

        can('edit', 'Contratos', {
            'gestor.mail': { $eq: user.email },
            'status': { $in: ['Aprovado'] }
        })

    }

    return build()
}